module.exports = __webpack_public_path__ + "static/media/jinx-lose.17e28aab.png";